import qs from 'qs'

export default {
  install(Vue) {

    const methods = {
      getQuery({ callback, camelcase = true} = {}) {
        const queryString = window.location.search.replace('?', '')
        let newParams = qs.parse(queryString) || {}
        if (camelcase)
          newParams = Vue.parse.toCamelcase(newParams)

        if (callback && typeof callback === 'function')
          return callback(newParams)
        else
          return newParams
      },
      updateQuery: function (query) {
        query = {...query}
        Vue.parse.sanitize(query)

        const path = window.location.pathname
        if (query && Object.keys(query).length > 0) {
          let params = qs.stringify(query, {
            arrayFormat: 'brackets',
            encode: false
          })

          if (params)
            history.replaceState({}, null, `${path}?${params}`)

        } else {
          history.replaceState({}, null, path)
        }
      }
    }

    Vue.utilUri = methods
    Vue.prototype.$utilUri = methods
  }
}
